function generateBlobHelper(result) {
    const base64 = result.data.base64;
    const decodedData = window.atob(base64);
    const uInt8Array = new Uint8Array(decodedData.length);

    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }

    let mimeType = result.data.mimeType;

    let blob = new Blob([uInt8Array], {type: mimeType});
    if (
        window.navigator &&
        window.navigator.msSaveOrOpenBlob
    ) return window.navigator.msSaveOrOpenBlob(blob);

    return blob;
}

export default generateBlobHelper;